export default __webpack_public_path__ + "static/media/qrc_logo.1db5d220.jpeg";